var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8081 9.49163V14.4833C17.8081 16.7833 15.9414 18.65 13.6414 18.65H6.35807C4.05807 18.65 2.19141 16.7833 2.19141 14.4833V9.54997C2.82474 10.2333 3.72474 10.625 4.69974 10.625C5.74974 10.625 6.75807 10.1 7.39141 9.2583C7.95807 10.1 8.92474 10.625 9.99974 10.625C11.0664 10.625 12.0164 10.125 12.5914 9.29163C13.2331 10.1166 14.2247 10.625 15.2581 10.625C16.2664 10.625 17.1831 10.2166 17.8081 9.49163Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4921 1.04175H7.49211L6.87545 7.17508C6.82545 7.74175 6.90878 8.27508 7.11711 8.75841C7.60045 9.89175 8.73378 10.6251 10.0004 10.6251C11.2838 10.6251 12.3921 9.90841 12.8921 8.76675C13.0421 8.40841 13.1338 7.99175 13.1421 7.56675V7.40841L12.4921 1.04175Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6338 6.89175L18.3921 4.58341C18.0421 2.06675 16.9005 1.04175 14.4588 1.04175H11.2588L11.8755 7.29175C11.8838 7.37508 11.8921 7.46675 11.8921 7.62508C11.9421 8.05841 12.0755 8.45841 12.2755 8.81675C12.8755 9.91675 14.0421 10.6251 15.2588 10.6251C16.3671 10.6251 17.3671 10.1334 17.9921 9.26675C18.4921 8.60008 18.7171 7.75841 18.6338 6.89175Z",
    fill: "#9CA3AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49137 1.04175C3.04138 1.04175 1.90804 2.06675 1.54971 4.60841L1.32471 6.90008C1.24137 7.79175 1.48304 8.65841 2.00804 9.33341C2.64137 10.1584 3.61637 10.6251 4.69971 10.6251C5.91637 10.6251 7.08304 9.91675 7.67471 8.83342C7.89138 8.45842 8.03304 8.02508 8.07471 7.57508L8.72471 1.05008H5.49137V1.04175Z",
    fill: "#9CA3AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45794 13.8834C8.39961 13.9917 7.59961 14.8917 7.59961 15.9584V18.65H12.3913V16.25C12.3996 14.5084 11.3746 13.6834 9.45794 13.8834Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.eac4b77a4f3ce62ddb82d1f703c4a2fd.svg";
export { ForwardRef as ReactComponent };